import React, { useEffect, useState } from 'react';
import LinkPlus from '../UI/LinkPlus.js';
import CuadroDatos from '../UI/CuadroDatos.js';
import BotoneraFiltros from '../UI/BotoneraFiltros.js';
import IconoMovimiento from '../UI/IconoMovimiento.js';
import IconoTitulo from '../UI/IconoTitulo.js';
import Paginador from '../UI/Paginador.js';
import TablaDatos from '../UI/TablaDatos.js';
import * as ModoPersona from '../constantes/ModoPersona.js';
import * as UI from '../constantes/UI.js';
import { NombreEquipo } from '../funciones/FuncionesEquipo.js';
import useGetListaURL from '../../hooks/useGetListaURL.js';
import styles from './TorneosPersona.module.css';

const TorneosPersona = (props) => {
  // usuario context not needed here
  const [planteles, setPlanteles] = useState(null);
  const [cantPaginas, setCantPaginas] = useState(null);
  const [pagina, setPagina] = useState(0);
  const { isCargando, erroresGetLista, fetchData, resetErroresGetLista } = useGetListaURL();
  const persona = props.persona;
  const idPersona = props.persona && props.persona.id;
  const esJugador = props.persona && props.persona.esJugador;
  const esTecnico = props.persona && props.persona.esTecnico;
  const [filtro, setFiltro] = useState(
    esJugador && esJugador === true ? ModoPersona.JUGADOR : esTecnico ? ModoPersona.TECNICO : null
  );
  const { TORNEOS_X_PAGINA } = UI.useUI();

  const filtroBotones = [
    { codigo: ModoPersona.JUGADOR, descripcion: 'Jugador' },
    { codigo: ModoPersona.TECNICO, descripcion: 'Técnico' },
  ];

  useEffect(() => {
    resetErroresGetLista();
  }, [resetErroresGetLista]);

  useEffect(() => {
    const SetearPlanteles = (planteles) => {
      if (planteles) {
        setPlanteles(planteles);
        if (planteles.length > 0) {
          setCantPaginas(Math.ceil(planteles.length / TORNEOS_X_PAGINA));
        } else {
          setCantPaginas(0);
        }
      }
    };

    if (idPersona !== null && filtro !== null) {
      if (filtro === ModoPersona.JUGADOR) {
        fetchData('jugadores/' + idPersona + '/torneos', SetearPlanteles);
      } else {
        fetchData('tecnicos/' + idPersona + '/torneos', SetearPlanteles);
      }
    } else {
      setPlanteles(null);
    }
  }, [fetchData, idPersona, filtro, TORNEOS_X_PAGINA]);

  const EsPaginaActual = (index) => {
    const primerIndice = Number(pagina) * TORNEOS_X_PAGINA;
    const ultimoIndice = (Number(pagina) + 1) * TORNEOS_X_PAGINA - 1;
    return Number(index) >= primerIndice && Number(index) <= ultimoIndice;
  };

  const plantelesPagina = planteles && planteles.filter((plantel, index) => EsPaginaActual(index));

  return (
    <CuadroDatos titulo="Torneos disputados" isCargando={isCargando} errores={erroresGetLista}>
      {esJugador && esTecnico && (
        <BotoneraFiltros
          filtros={filtroBotones}
          selected={filtro}
          onFiltroElegido={setFiltro}
          onResetPagina={setPagina}
        />
      )}
      {planteles && !isCargando && (
        <React.Fragment>
          <TablaDatos
            estilo={`${styles.tablaTorneos}`}
            lista={planteles}
            textoVacia="La persona no disputó ningún torneo"
          >
            <tbody>
              <tr key="0" className={`${styles.titulos}`}>
                <td className={`${styles.torneo}`}>Torneo</td>
                <td className={`${styles.equipo}`}>Equipo</td>
                <td className={`${styles.pj}`}>{filtro === ModoPersona.JUGADOR ? 'PJ' : 'PD'}</td>
                {filtro === ModoPersona.JUGADOR && (
                  <React.Fragment>
                    <td className={`${styles.goles}`}>
                      {persona.puesto && persona.puesto.codigo === 'AR' ? 'GR' : 'GC'}
                    </td>
                    <td className={`${styles.pj}`}>Exp</td>
                  </React.Fragment>
                )}
              </tr>
              {plantelesPagina.map((plantel) => (
                <tr key={plantel.idPlantel}>
                  <td>
                    <LinkPlus to={'/torneos/' + plantel.id} adaptativo={true}>
                      {plantel.descripcion}
                    </LinkPlus>
                    <IconoTitulo objeto={plantel} />
                    <IconoMovimiento objeto={plantel} />
                  </td>
                  <td>
                    <LinkPlus
                      to={'/torneos/' + plantel.id + '/equipo/' + plantel.equipo.id}
                      adaptativo={true}
                    >
                      {NombreEquipo(plantel.equipo)}
                    </LinkPlus>
                  </td>
                  <td>{plantel.partidosJugados}</td>
                  {filtro === ModoPersona.JUGADOR && (
                    <React.Fragment>
                      <td>
                        {persona.puesto && persona.puesto === 'AR'
                          ? plantel.golesRecibidos
                          : plantel.golesConvertidos}
                      </td>
                      <td>{plantel.expulsiones}</td>
                    </React.Fragment>
                  )}
                </tr>
              ))}
            </tbody>
          </TablaDatos>
          <Paginador
            cantPaginas={cantPaginas}
            cantBotones="5"
            paginaActual={pagina}
            onPaginaElegida={setPagina}
          />
        </React.Fragment>
      )}
    </CuadroDatos>
  );
};

export default TorneosPersona;
